import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ReactComponent as RestIcon } from '../../icons/rest-quarter.svg';

import './RestMark.scss';

const RestMark = ({ countIn = 0 }) => {
  const { t } = useTranslation();
  if (countIn > 0) {
    return (
      <span className="RestMark RestMark--count-in" aria-label={t('player.countIn')}>
        {Array.from({ length: Math.ceil(countIn) }, (_, i) => (
          <span key={i}>{i + 1}</span>
        ))}
      </span>
    );
  }

  return (
    <span className="RestMark" aria-label={t('player.rest')}>
      <RestIcon className="glyph" aria-hidden="true" />
    </span>
  );
};

RestMark.propTypes = { countIn: PropTypes.number };

export default RestMark;
